module.exports = __webpack_public_path__ + "img/291816e.jpg";